import { useCallback, useMemo } from 'react';
import { useOrganizationData } from '@/contexts/OrganizationContext';
import { DateInput, FormattedZonedDate, TimezoneFormatOptions, formatWithTimezone, resolveActiveTimezone } from '@/utils/timezone';
import { getSessionSubject } from '@/session/token';

export const useTimezoneFormatter = () => {
  const { timezone, isOrgTimezone, organization } = useOrganizationData();
  const organizationName = organization?.name ?? null;
  const subject = getSessionSubject();

  const activeTimezone = useMemo(() => timezone || resolveActiveTimezone(organizationName, subject), [organizationName, subject, timezone]);

  const format = useCallback(
    (input: DateInput, options?: TimezoneFormatOptions): FormattedZonedDate => {
      return formatWithTimezone(input, activeTimezone, isOrgTimezone, options);
    },
    [activeTimezone, isOrgTimezone]
  );

  return {
    format,
    timezone: activeTimezone,
    isOrgTimezone,
  };
};
